// removed by extract-text-webpack-plugin
module.exports = {"container":"oaXMUJnP0FAkYa5C9uCSW","info":"_32bnxBSXGtG7iSo8BNFNHm","inProgress":"yiIeJRUP0lZWCnjEvI2Yy","rating":"AOb0vLgKWDV9HlSOwQnQq","star":"_7b5mZ_i4Tzk642SxgXUBf","full":"c8-1a2uxQA5R5xWUWqp7x","actions":"vJ4Mk2BMkg5W23zdOX35l"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e23668b8","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/shared/CallInfo/CallInfo.less
// module id = YP7N
// module chunks = 1